import {theme as presetTheme} from '../../tailwind-preset';

// v3 > v4로 업그레이드하면서 기존 resolveConfig가 제거되어 tailwind-preset.js을 이용하여 테마를 생성합니다.
const {
  extend: {colors, ...restExtends},
  fonts,
  spacing,
  ...restTheme
} = presetTheme;

export const theme = {
  ...restTheme,
  ...restExtends,
  colors: colors() as Record<string, string>,
  fonts: fonts() as Record<string, string>,
  spacing: spacing as Record<string, string>,
};
